module.exports = __webpack_public_path__ + "static/media/capel.dd289485.webp";